import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import StorageUnitDTO from '../../DTOs/StorageUnit/StorageUnitDTO';
import MobileCard from './MobileCard';
import { USDollar } from '../../utilities/Constants';

export default function HoldStorageUnitCardMobile(props) {
    const { storageUnit, showHoldModal, showAssignModal } = props;

    return (
        <MobileCard
            title={`Unit ${storageUnit.name}`}
            subtitle={`${storageUnit.facility.name} \u2013 ${storageUnit.section.name}`}
            status={storageUnit.hold
                ? { label: 'On hold', color: 'warning' }
                : { label: 'Available', color: 'success' }}
            fields={[
                { label: 'Size', value: storageUnit.storageSize },
                { label: 'Type', value: storageUnit.storageUnitType.name },
                { label: 'Climate', value: storageUnit.climateControlled ? 'Controlled' : 'Not controlled' },
                { label: 'Price', value: USDollar.format(storageUnit.price) },
            ]}
            actions={
                <>
                    <Button variant={'contained'} onClick={showHoldModal}>
                        {storageUnit.hold ? 'Make Unit Available' : 'Hold Storage Unit'}
                    </Button>
                    <Button variant={'outlined'} color={'error'} onClick={showAssignModal}>
                        Manually Assign
                    </Button>
                </>
            }
        />
    );
}

HoldStorageUnitCardMobile.propTypes = {
    storageUnit: PropTypes.objectOf(StorageUnitDTO),
    showHoldModal: PropTypes.func,
    showAssignModal: PropTypes.func,
};
